export const consts = {
  FALSE: 0,
  TRUE: 1,

  IS_COMMON_DEDICATED: 0,
  IS_COMMON_SHARED: 1,

  STATUS_NEW: 1,
  STATUS_ONLINE: 2,
  STATUS_OFFLINE: 3,
  STATUS_BANNED: 4,

  INTERN_SCOPE_ALL: 1, // 全部实习生
  INTERN_SCOPE_SPECIFIC: 2, // 指定实习生

  KNOWLEDGE_STATUS_ACTIVE: 2,
}

export const COURSE_FILE_TYPES = {
  IMAGE: 'img',
  VIDEO: 'video',
  PDF: 'pdf',
  PPT: 'ppt',
  WORD: 'word',
  EXCEL: 'excel',
}

export const opts = {
  isCommonMaps: [
    {value: consts.IS_COMMON_DEDICATED, label: '专用'},
    {value: consts.IS_COMMON_SHARED, label: '通用'},
  ],
  statusMaps: [
    {value: consts.STATUS_NEW, label: '新创建'},
    {value: consts.STATUS_ONLINE, label: '已上架'},
    {value: consts.STATUS_OFFLINE, label: '已下架'},
    {value: consts.STATUS_BANNED, label: '已作废'},
  ],
  InternScopeMaps: [
    {value: consts.INTERN_SCOPE_ALL, label: '全部'},
    {value: consts.INTERN_SCOPE_SPECIFIC, label: '指定'},
  ],
}

export function getOptionLabel (options, value) {
  const item = options.find(option => Number(option.value) === Number(value))
  return item ? item.label : ''
}

export function getCourseStatusLabel (status) {
  return getOptionLabel(opts.statusMaps, status) || '未知状态'
}


export function getCourseStatusType (status) {
  switch (Number(status)) {
    case consts.STATUS_ONLINE:
      return 'success'
    case consts.STATUS_OFFLINE:
      return 'warning'
    case consts.STATUS_BANNED:
      return 'danger'
    default:
      return 'info'
  }
}

export function getCourseStatusActions (status, isSuperAdmin = true) {
  switch (Number(status)) {
    case consts.STATUS_NEW:
      return [
        {name: 'online', label: '上架', type: 'success', apiName: 'onlineInternTrainingCourse', successText: '上架成功'},
      ]
    case consts.STATUS_ONLINE:
      return [
        {name: 'offline', label: '下架', type: 'warning', apiName: 'offlineInternTrainingCourse', successText: '下架成功'},
      ]
    case consts.STATUS_OFFLINE:
      return [
        {name: 'online', label: '上架', type: 'success', apiName: 'onlineInternTrainingCourse', successText: '上架成功'},
        ...(isSuperAdmin
          ? [{name: 'ban', label: '作废', type: 'danger', apiName: 'banInternTrainingCourse', successText: '作废成功'}]
          : []),
      ]
    case consts.STATUS_BANNED:
      return isSuperAdmin
        ? [{name: 'active', label: '激活', type: 'primary', apiName: 'activeInternTrainingCourse', successText: '激活成功'}]
        : []
    default:
      return []
  }
}

export function isCourseRelationEditLocked (id, status) {
  return Number(id) > 0 && [
    consts.STATUS_ONLINE,
    consts.STATUS_OFFLINE,
  ].includes(Number(status))
}

export function buildCourseKnowledgeQueryParams ({is_common: isCommon, customerid}) {
  const params = {
    status: [consts.KNOWLEDGE_STATUS_ACTIVE],
    is_common: Number(isCommon),
  }

  if (Number(isCommon) === consts.IS_COMMON_DEDICATED && customerid) {
    params.customerid = [customerid]
  }

  return params
}

export const COURSE_UPLOAD_TYPE_CONFIGS = {
  [COURSE_FILE_TYPES.IMAGE]: {
    accept: ['image/jpeg', 'image/png', 'image/jpg'],
    extensions: ['jpg', 'jpeg', 'png'],
    maxFiles: 0,
    maxSizeMB: 20,
    label: '图片',
  },
  [COURSE_FILE_TYPES.VIDEO]: {
    accept: ['video/mp4', 'video/avi', 'video/x-msvideo', 'video/quicktime'],
    extensions: ['mp4', 'avi', 'mov'],
    maxFiles: 0,
    maxSizeMB: 1024,
    label: '视频',
  },
  [COURSE_FILE_TYPES.PDF]: {
    accept: ['application/pdf'],
    extensions: ['pdf'],
    maxFiles: 0,
    maxSizeMB: 100,
    label: 'PDF',
  },
  [COURSE_FILE_TYPES.PPT]: {
    accept: [
      'application/vnd.ms-powerpoint',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ],
    extensions: ['ppt', 'pptx'],
    maxFiles: 0,
    maxSizeMB: 100,
    label: 'PPT',
  },
  [COURSE_FILE_TYPES.WORD]: {
    accept: [
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
    extensions: ['doc', 'docx'],
    maxFiles: 0,
    maxSizeMB: 100,
    label: 'Word',
  },
  [COURSE_FILE_TYPES.EXCEL]: {
    accept: [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ],
    extensions: ['xls', 'xlsx'],
    maxFiles: 0,
    maxSizeMB: 100,
    label: 'Excel',
  },
}


export function getFileExtension (name) {
  const parts = String(name || '').split('.')
  return parts.length > 1 ? parts.pop().toLowerCase() : ''
}

export function getCourseFileTypeByFile (file) {
  const type = String((file && file.type) || '')
  const ext = getFileExtension(file && file.name)

  if (type.indexOf('image/') === 0) {
    return COURSE_FILE_TYPES.IMAGE
  }
  if (type.indexOf('video/') === 0) {
    return COURSE_FILE_TYPES.VIDEO
  }
  if (Object.keys(COURSE_FILE_TYPES).some(key => COURSE_FILE_TYPES[key] === type)) {
    return type
  }

  return Object.keys(COURSE_UPLOAD_TYPE_CONFIGS).find(fileType => {
    const config = COURSE_UPLOAD_TYPE_CONFIGS[fileType]
    return config.accept.includes(type) || config.extensions.includes(ext)
  }) || ''
}

export function getCourseUploadConfig (fileType) {
  if (fileType && COURSE_UPLOAD_TYPE_CONFIGS[fileType]) {
    const config = COURSE_UPLOAD_TYPE_CONFIGS[fileType]
    const maxSizeLabel = config.maxSizeMB >= 1024
      ? `${(config.maxSizeMB / 1024).toFixed(config.maxSizeMB % 1024 === 0 ? 0 : 1)}GB`
      : `${config.maxSizeMB}MB`
    const maxFilesLabel = config.maxFiles > 0 ? `最多 ${config.maxFiles} 个` : '可上传多个'

    return {
      ...config,
      tip: `支持上传${config.label}，${maxFilesLabel}，单个最大 ${maxSizeLabel}`,
    }
  }

  const configs = Object.keys(COURSE_UPLOAD_TYPE_CONFIGS).map(type => COURSE_UPLOAD_TYPE_CONFIGS[type])
  return {
    accept: configs.reduce((result, item) => result.concat(item.accept), []),
    extensions: configs.reduce((result, item) => result.concat(item.extensions), []),
    maxFiles: 0,
    maxSizeMB: Math.max.apply(null, configs.map(item => item.maxSizeMB)),
    tip: '支持图片、视频、PDF、PPT、Word、Excel，可上传多个文件，单个文件大小按类型限制',
  }
}

export function validateCourseUploadFile (file, currentFiles = []) {
  const fileType = getCourseFileTypeByFile(file)
  if (!fileType) {
    return {
      valid: false,
      fileType,
      message: getCourseUploadConfig().tip,
      replaceAll: false,
    }
  }

  const config = getCourseUploadConfig(fileType)
  const maxSize = config.maxSizeMB * 1024 * 1024
  const ext = getFileExtension(file && file.name)

  if (!file || (!config.accept.includes(file.type) && !config.extensions.includes(ext))) {
    return {
      valid: false,
      fileType,
      message: config.tip,
      replaceAll: false,
    }
  }

  if (Number(file.size) > maxSize) {
    return {
      valid: false,
      fileType,
      message: config.tip,
      replaceAll: false,
    }
  }

  const currentTypeCount = Array.isArray(currentFiles)
    ? currentFiles.filter(item => getCourseFileTypeByFile(item) === fileType).length
    : 0
  if (config.maxFiles > 0 && currentTypeCount >= config.maxFiles) {
    return {
      valid: false,
      fileType,
      message: config.tip,
      replaceAll: false,
    }
  }

  return {
    valid: true,
    fileType,
    message: '',
    replaceAll: false,
  }
}



// WEBPACK FOOTER //
// ./src/views/training/training-course-intern.constants.js